<ng-template #modalTemplate>
    <div class="modal-header">
        <ng-content select="[modal-header]"></ng-content>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <ng-content select="[modal-body]"></ng-content>
    </div>
</ng-template>